import { Typography } from '@sunwebgroup/uds-ui/typography'
import { isEmpty } from 'ramda'
import * as React from 'react'

import { useIntl } from '@/intl'
import { useOptimizelyFlagContext } from '@/scopes/common/infrastructure/ab-testing/optimizely/useOptimizely'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { routesSelector } from '@/scopes/prices/components/selectors'
import { CollapseByHeight } from '@/scopes/prices/components/TransportSelector/CollapseByHeight'
import { Column } from '@/scopes/prices/components/TransportSelector/Column'
import { FlightCard } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightCard'
import { FlightCardNew } from '@/scopes/prices/components/TransportSelector/FlightSelector/FlightSelectorNew/FlightCardNew'
import { ArrivalTitle, DepartureTitle } from '@/scopes/prices/components/TransportSelector/FlightSelector/Headers'
import { createFlightComponentInteractionEvent } from '@/scopes/prices/domain/analytics'
import { PricesActionsContext } from '@/scopes/prices/domain/PricesActionsContext'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import styles from './FlightSelectorDesktop.module.css'

export function FlightSelectorDesktop() {
  const { inboundRoutes, outboundRoutes } = usePricesSelector(routesSelector)

  if (isEmpty(outboundRoutes) || isEmpty(inboundRoutes))
    return null

  return (
    <>
      <FlightSelector />
    </>
  )
}

function FlightSelector() {
  const { enableAlternateFlightVisualisation } = useOptimizelyFlagContext()
  const Card = enableAlternateFlightVisualisation ? FlightCardNew : FlightCard
  const { setInboundRouteId, setOutboundRouteId } = React.use(PricesActionsContext)
  const intl = useIntl()
  const { inboundRoutes, outboundRoutes, selectedOutboundRouteId, selectedInboundRouteId }
    = usePricesSelector(routesSelector)
  const { sendEvent } = useAnalytics()

  function handleCollapseToggle(result: string) {
    sendEvent(createFlightComponentInteractionEvent({ type: 'outbound', result }))
  }

  const content = (
    <div className={styles.wrapper} id="FlightSelector">
      <Column className={styles.column} value={selectedOutboundRouteId as string}>
        <DepartureTitle />
        {outboundRoutes.map((item, index) => (
          <Card
            key={index}
            {...item}
            setSelected={setOutboundRouteId}
            isSelected={selectedOutboundRouteId === item.id}
          />
        ))}
      </Column>
      <Column className={styles.column} value={selectedInboundRouteId as string}>
        <ArrivalTitle />
        {inboundRoutes.map((item, index) => (
          <Card
            key={index}
            {...item}
            setSelected={setInboundRouteId}
            isSelected={selectedInboundRouteId === item.id}
          />
        ))}
      </Column>
    </div>
  )
  return (
    <div className={styles.flightSelectorContainer}>
      <Typography className={styles.flightSelectorTitle} variant="display-f-regular">
        {intl.formatMessage({ id: 'prices_transport_selector_flight-selector_title' })}
      </Typography>

      {outboundRoutes.length < 3
        ? (
            <>{content}</>
          )
        : (
            <CollapseByHeight
              openText={intl.formatMessage({ id: 'prices_transport_selector_flight-selector-show-less' })}
              closeText={intl.formatMessage({ id: 'prices_transport_selector_flight-selector-show-more' })}
              height="370px"
              onClick={handleCollapseToggle}
            >
              {content}
            </CollapseByHeight>
          )}
    </div>
  )
}
